import {
    Core as Service
} from '@/services/Core';

const state = {
    tenants_item: {},
    tenants: null,
    tenants_error: null
};
const getters = {
    tenant_name: state => {
        try {
            return state.tenants_item.name;
        } catch (error) {
            return '';
        }
    },
    customer_id: state => {
        try {
            return state.tenants_item.customer_id;
        } catch (error) {
            return false;
        }
    },
    subscription_id: state => {
        try {
            return state.tenants_item.subscription_id;
        } catch (error) {
            return false;
        }
    },
    primary_domain: state => {
        try {
            return state.tenants_item.domain_urls.find(obj => {
                return obj.is_primary === true
            })
        } catch (error) {
            return { domain: '', is_primary: false }
        }
    },
    login_url: state => {
        try {
            return state.tenants_item.login_logout_options.login_url;
        } catch (error) {
            return '';
        }
    },
    logout_url: state => {
        try {
            return state.tenants_item.login_logout_options.logout_url;
        } catch (error) {
            return '';
        }
    },
    registration_redirect_url: state => {
        try {
            return state.tenants_item.registration_options.redirect_url;
        } catch (error) {
            return '';
        }
    }
};

const mutations = {
    mutate(state, payload) {
        state[payload.property] = payload.with;
    }
};

const actions = {
    async createItem(context, {
        endpoint,
        data,
        params = {}
    }) {
        let response;
        try {
            response = await Service.create_item(endpoint, data, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: response
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async getItem(context, {
        endpoint,
        uuid,
        params = {}
    }) {
        let response;
        try {
            response = await Service.get_item(endpoint, uuid, params);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: response
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async getItems(context, {
        endpoint,
        params = {}
    }) {
        let response;
        try {
            response = await Service.get_items(endpoint, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: response
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}`,
            with: response.results
        });
        context.commit('mutate', {
            property: `${endpoint}_count`,
            with: response.count
        });
        context.commit('mutate', {
            property: `${endpoint}_next`,
            with: response.next
        });
        context.commit('mutate', {
            property: `${endpoint}_previous`,
            with: response.next
        });
        return response;
    },

    async patchItem(context, {
        endpoint,
        uuid,
        data,
        params = {}
    }) {
        let response;
        try {
            response = await Service.patch_item(endpoint, uuid, data, params);
        } catch (error) {
            console.error(error.response.data);
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: response
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async updateItem(context, {
        endpoint,
        uuid,
        data,
        params = {}
    }) {
        let response;
        try {
            response = await Service.update_item(endpoint, uuid, data, params);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: response
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: response
        });
        return response;
    },

    async deleteItem(context, {
        endpoint,
        uuid
    }) {
        let response;
        try {
            response = await Service.delete_item(endpoint, uuid);
        } catch (error) {
            console.error(error.response.data)
            context.commit('mutate', {
                property: `${endpoint}_error`,
                with: response
            });
            throw error;
        }
        context.commit('mutate', {
            property: `${endpoint}_item`,
            with: endpoint === 'tenants' ? { name: '' } : null
        });
        return response;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}